/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { ApiEntity } from 'app/api/models/api-entity.model';

export interface FlatTreeNode extends ApiEntity {
  id: number;
  expandable: boolean;
  name: string;
  level: number;
  type: string;
  selected: boolean;
  data: any;
  parents: number[],
  renderData: any;

}

export class TreeNode extends ApiEntity {

  public expanded = false;
  public visible = true;
  public focus = false;
  public hover = false;
  public allowActions = true;
  public editMode = false;
  public parentId = null;
  public data = null;

    constructor(
        id: number = null,
        public name: string = '',
        public hasChildren: boolean = false,
        public allowNewChildren: boolean = false,
        public accessAllowed: boolean = false,
        public readOnly: boolean = false,
        public isLink: boolean = false,
        public children: TreeNode[] = [],
        public parents: number[] = [],
        public selected: boolean = false, 
        public parent: TreeNode = null,
        public parentBreadcrumb: string = '',
        public nodeType: string = '',
    ) {
        super(id);
    }

    public get isRoot() {
      return this.parent === null;
    }

    
    public get hasLoadedChildren(): boolean {
        return this.children && this.children.length > 0;
    }

    public get visibleChildren(): TreeNode[] {
        return this.children.filter(f => f.visible == true);
    }

    public get hasLoadedVisibleChildren(): boolean {        
        return this.children && this.visibleChildren.length > 0;
    }

    public get displayName(): string {
        return this.name;
    }

    public getChildByName(nameToMatch: string): TreeNode {
        const nameToMatchLowerCase = nameToMatch.toLowerCase();
        return this.children.find(x => x.name.toLowerCase() === nameToMatchLowerCase)
    }

    public getChildByFileName(nameToMatch: string): TreeNode {
        const nameToMatchLowerCase = nameToMatch.toLowerCase();
        return this.children.find(x => (x.name).toLowerCase() === nameToMatchLowerCase)
    }

    public get breadcrumb(): string {
        return this.parentBreadcrumb + '/' + this.name;
    }

    getExpandedNodes(): number[] {
    const expandedNodes: number[] = [];
        this.getExpandedNodesForNode(this, expandedNodes);
        return expandedNodes;
    }

    setExpandedNodes(expandedNodes: number[]) {
        this.setExpandedNodesForNode(this, expandedNodes);
    }

  private getExpandedNodesForNode(node: TreeNode, expandedNodes: number[]) {
    if (node.expanded) {
      expandedNodes.push(node.id);
      if (node.hasLoadedChildren) {
        node.children.forEach((item: TreeNode) => {
          this.getExpandedNodesForNode(item, expandedNodes);
        });
      }
    }
  }

  private setExpandedNodesForNode(node: TreeNode, expandedNodes: number[]) {
    const nodeShouldBeExpanded = expandedNodes.find(f => f == node.id)
    if (nodeShouldBeExpanded != null) {
      node.expanded = true;
    }
    if (node.hasLoadedChildren) {
      node.children.forEach((item: TreeNode) => {
        this.setExpandedNodesForNode(item, expandedNodes);
      });
    }
  }
    
}

export class TreeFocusEvent {
    constructor(thisId: number) {

    }
}
